import React from 'react';
import Styles from './simple-radio-styles.scss';
const SimpleCheckboxBase = ({ name, value, onChangeParam, disabled, defaultChecked = false, readOnly = false }) => {
    const handleOnChange = (e) => {
        if (onChangeParam)
            onChangeParam(e.target.value);
    };
    return (React.createElement("label", { className: Styles.container },
        React.createElement("input", { type: "radio", name: name, onChange: handleOnChange, value: value, disabled: disabled, defaultChecked: defaultChecked, readOnly: readOnly, onClick: e => readOnly && e.preventDefault() }),
        React.createElement("span", { className: Styles.checkmark })));
};
export default SimpleCheckboxBase;
